import type { CustomDataMap } from 'owa-analytics-types';

export type GrowthTelemetryCurrentSku =
    | 'Free'
    | 'Basic'
    | 'Personal'
    | 'Family'
    | 'Premium'
    | 'Pro';

export type GrowthTelemetryEventData = {
    Scenario: string;
    Action: string;
    EntryPoint: string;
    HostType?: string;
    PartnerId?: string;
    CmmId?: string;
    ExperienceId?: string;
    CurrentSKU?: GrowthTelemetryCurrentSku;
    ActionSuccess?: boolean;
    ActionErrorCategory?: string;
    Duration?: number;
};

/**
 * Adds the shared Growth telemetry schema to feature-specific custom data. The catalogued event
 * name must remain a literal in the direct logUsage or logCoreUsage call.
 */
export function getGrowthTelemetryData<TAdditionalDataKeys extends string = never>(
    eventData: GrowthTelemetryEventData,
    additionalData?: CustomDataMap<TAdditionalDataKeys>
): CustomDataMap {
    const growthTelemetryData: CustomDataMap = {
        ...additionalData,
        ...eventData,
    };
    return growthTelemetryData;
}
